import React from 'react';

export default function TermsAndService() {
  return (
<div className="max-w-xl mx-auto px-4 py-16 sm:px-6 lg:px-8 lg:max-w-7xl">
  <div className="relative">
    <h2 className="text-center text-3xl font-bold tracking-tight font-title">Terms of Service</h2></div><div className="relative mt-12">
  <div>
  <p>
    <strong>TERMS OF USE </strong><br />
    <br />
    <strong>TABLE OF CONTENTS&nbsp;</strong>
  </p>
  <p><a href="/terms-of-service#1"><u>1. AGREEMENT TO TERMS</u></a></p>
  <p>
    <a href="/terms-of-service#2"><u>2. OWNERSHIP OF INVENTIONS, PROPRIETARY INFORMATION, AND NON-COMPETITION</u></a>
  </p>

<p>
	<a href="/terms-of-service#3"><u>3. NOTICE OF RIGHTS INFRINGEMENT</u></a>
</p>

<p>
	<a href="/terms-of-service#4"><u>4. USER REPRESENTATIONS</u></a>
</p>

<p>
	<a href="/terms-of-service#5"><u>5. USER REGISTRATION</u></a>
</p>

<p>
	<a href="/terms-of-service#6"><u>6. MARKETPLACE OFFERINGS</u></a>
</p>

<p>
	<a href="/terms-of-service#7"><u>7. PURCHASES AND PAYMENT</u></a>
</p>

<p>
	<a href="/terms-of-service#8"><u>8. REFUNDS POLICY</u></a>
</p>

<p>
	<a href="/terms-of-service#9"><u>9. PROHIBITED ACTIVITIES</u></a>
</p>

<p>
	<a href="/terms-of-service#10"><u>10. USER GENERATED CONTRIBUTIONS</u></a>
</p>

<p>
	<a href="/terms-of-service#11"><u>11. CONTRIBUTION LICENSE</u></a>
</p>

<p>
	<a href="/terms-of-service#12"><u>12. MOBILE APPLICATION LICENSE</u></a>
</p>

<p>
	<a href="/terms-of-service#13"><u>13. SOCIAL MEDIA</u></a>
</p>

<p>
	<a href="/terms-of-service#14"><u>14. SUBMISSIONS</u></a>
</p>

<p>
	<a href="/terms-of-service#15"><u>15. THIRD-PARTY WEBSITES AND CONTENT</u></a>
</p>

<p>
	<a href="/terms-of-service#16"><u>16. ADVERTISERS</u></a>
</p>

<p>
	<a href="/terms-of-service#17"><u>17. SITE MANAGEMENT</u></a>
</p>

<p>
	<a href="/terms-of-service#18"><u>18. PRIVACY POLICY</u></a>
</p>

<p>
	<a href="/terms-of-service#19"><u>19. COPYRIGHT INFRINGEMENTS</u></a>
</p>

<p>
	<a href="/terms-of-service#20"><u>20. TERM AND TERMINATION</u></a>
</p>

<p>
	<a href="/terms-of-service#21"><u>21. MODIFICATIONS AND INTERRUPTIONS</u></a>
</p>

<p>
	<a href="/terms-of-service#22"><u>22. GOVERNING LAW</u></a>
</p>

<p>
	<a href="/terms-of-service#23"><u>23. DISPUTE RESOLUTION</u></a>
</p>

<p>
	<a href="/terms-of-service#24"><u>24. CORRECTIONS</u></a>
</p>

<p>
	<a href="/terms-of-service#25"><u>25. ASSUMPTION OF RISK</u></a>
</p>

<p>
	<a href="/terms-of-service#26"><u>26. DISCLAIMER</u></a>
</p>

<p>
	<a href="/terms-of-service#27"><u>27. LIMITATIONS OF LIABILITY</u></a>
</p>

<p>
	<a href="/terms-of-service#28"><u>28. INDEMNIFICATION</u></a>
</p>

<p>
	<a href="/terms-of-service#29"><u>29. USER DATA</u></a>
</p>

<p>
	<a href="/terms-of-service#30"><u>30. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES</u></a>
</p>

<p>
	<a href="/terms-of-service#31"><u>31. CALIFORNIA USERS AND RESIDENTS</u></a>
</p>

<p>
	<a href="/terms-of-service#32"><u>32. USER LIKENESS AND CONTENT USE</u></a>
</p>

<p>
	<a href="/terms-of-service#33"><u>33. MISCELLANEOUS</u></a>
</p>

<p>
	<a href="/terms-of-service#34"><u>34. CONTACT US</u></a>
</p>

<p>&nbsp;</p>

<p id="1"><strong>1. AGREEMENT TO TERMS</strong></p>

<p>
	These Terms of Use constitute a legally binding agreement made between you, whether personally or on behalf of an
	entity (“you”) and the company LSAT Gains. as formed within the State of Delaware, USA, doing business as
	LSAT Gains ("<strong>LSAT Gains</strong>", “<strong>Company</strong>,”
	“<strong>we</strong>”, “<strong>us</strong>”, or “<strong>our</strong>”),
	concerning your access to and use of the LSAT Gains website as well as any other media form, media channel, mobile
	website or mobile application related, linked, or otherwise connected thereto (collectively, the
	“Site”). Users will engage and interact with each other in a peer-to-peer manner. LSAT Gains makes no statements, assurances,
	or guarantees regarding the quality of their platform, including the software.
</p>

<p>&nbsp;</p>

<p id="2"><strong>2. Notice of Rights Infringement</strong></p>

<p>
	If any part of the Site or these terms infringes upon your rights, you must promptly notify LSAT Gains by sending an email
	to contact@lsatgains.com with the subject line "NOTICE OF RIGHTS INFRINGEMENT." In your email, please provide a
	detailed explanation of the specific rights that have been violated and the remedy you expect from LSAT Gains.
</p>

<p>
	Please note that if you send an email to the contact@lsatgains.com address without providing a detailed explanation of the
	infringement, LSAT Gains is not obligated to address the potential issue. Furthermore, if you use the method described in
	this section to email the company for purposes other than reporting a breach, such as for marketing or solicitation,
	you (including any party you represent) agree to pay a fee of $900 USD per email sent from your email address or any
	email address associated with the message. This payment is necessary to cover administrative expenses.
</p>

<p>&nbsp;</p>

<p id="3"><strong>3. USER REPRESENTATIONS</strong></p>

<p>
	By using the Site or the LSAT Exams, you represent and warrant that: (1) all registration information you
	submit will be true, accurate, current, and complete; (2) you will maintain the accuracy of such information and
	promptly update such registration information as necessary; (3) you have the legal capacity and you agree to comply
	with these Terms of Use; (4) you are not under the age of 13; (5) you are not a minor in the jurisdiction in which
	you reside, or if a minor, you have received parental permission to use the Site; (6) you will not access the Site
	or the LSAT Exams through automated or non-human means, whether through a bot, script or otherwise; (7)
	you will not use the Site for any illegal or unauthorized purpose; and (8) your use of the Site or the Marketplace
	Offerings will not violate any applicable law or regulation. You further represent that you are not from any nation
	featured on the United Nations, European Union, United States, or other sanctions country list, including but not
	limited to Afghanistan, Sudan, Iran, Iraq, North Korea, or Burma; that you are not from a location that is subject
	to sanctions due to acts of war, terrorist activities, or the sponsorship of terrorist groups; and that you are not
	a citizen or resident of Russia, Ukraine, and/or Belarus, and will not use any Service while being in these
	countries.
</p>

<p>
	If you provide any information that is untrue, inaccurate, not current, or incomplete, we have the right to suspend
	or terminate your account and refuse any and all current or future use of the Site (or any portion thereof).&nbsp;
</p>

<p>
	You may not use the Site or the LSAT Exams for any illegal or unauthorized purpose nor may you, in the
	use of LSAT Exams, violate any laws. Among unauthorized LSAT Exams are the following:
	intoxicants of any sort; illegal drugs or other illegal products; alcoholic beverages; games of chance; and
	pornography or graphic adult content, images, or other adult products. Postings of any unauthorized products or
	content may result in immediate termination of your account and a lifetime ban from use of the Site.&nbsp;
</p>

<p>
	We are a service provider and make no representations as to the safety, effectiveness, adequacy, accuracy,
	availability, prices, ratings, reviews, or legality of any of the information contained on the Site or the
	displayed or offered through the Site. You understand and agree that the content of the Site
	does not contain or constitute representations to be reasonably relied upon, and you agree to hold us harmless from
	any errors, omissions, or misrepresentations contained within the Site’s content.&nbsp;
</p>

<p>
	These Terms are designed to form a legally binding agreement between you and LSAT Gains including your successors,
	replacements, or administrator of your legal estate.
</p>

<p>
	If you represent a natural person as a third party, you warrant that you are fully authorized, and if necessary,
	licensed in your country/location to act on behalf of such a natural person.
</p>

<p>
	You warrant and undertake that at all times you have the ability to enter into agreements for and on behalf of any
	third party that you represent and furthermore, understand that if you act outside of capacity, you are still
	binding that entity insomuch as you are an agent for that third party.
</p>

<p>
	If you act without the legal capacity to do so, not through a misunderstanding of rights between you and the third
	party associated with a position, but through no actual connection to that third party (and therefore hold no legal
	liability to bind that third party), you will be held personally responsible for any and all losses associated with
	your misrepresentation.
</p>

<p>&nbsp;</p>

<p id="5"><strong>5. USER REGISTRATION</strong></p>

<p>
	In order to purchase a membership, take an exam, book a class, or access other features of the Site, you are
	required to create a personal account. Each account is intended for the exclusive use of the member who creates it.
	Sharing of accounts is strictly prohibited under all circumstances. When setting up your account, it is essential to
	provide accurate and complete information.You are solely responsible for all activities carried out on your account,
	and it is crucial to maintain the security of your account password. Any unauthorized use or breach of security must
	be reported to us immediately. It is strictly prohibited to share your account details with any other party or
	individual. Each person should operate only one account.
</p>

<p>&nbsp;</p>

<p id="6"><strong>6. MARKETPLACE OFFERINGS</strong></p>

<p>
	All LSAT Exams are subject to availability, and we cannot guarantee that LSAT Exams will be in
	stock. Certain LSAT Exams may be available exclusively online through the Site. Such Marketplace
	Offerings may have limited quantities and are subject to return or exchange only according to our Return
	Policy.&nbsp;
</p>

<p>
	We reserve the right to limit the quantities of the LSAT Exams offered or available on the Site. All
	descriptions or pricing of the LSAT Exams are subject to change at any time without notice, at our sole
	discretion. We reserve the right to discontinue any LSAT Exams at any time for any reason. We do not
	warrant that the
</p>

<p>
	quality of any of the LSAT Exams purchased by you will meet your expectations or that any errors in the
	Site will be corrected.&nbsp;
</p>

<p>&nbsp;</p>

<p id="7"><strong>7. PURCHASES AND PAYMENT</strong></p>

<p>We accept the following forms of payment:&nbsp;</p>

<p className="ml-20">- Visa&nbsp;</p>

<p className="ml-20">- Mastercard&nbsp;</p>

<p className="ml-20">- American Express&nbsp;</p>

<p className="ml-20">- PayPal&nbsp;</p>

<p className="ml-20">- Stripe&nbsp;</p>

<p className="ml-20">- Link&nbsp;</p>

<p>
	You agree to provide current, complete, and accurate purchase and account information for all purchases of the
	LSAT Exams made via the Site. You further agree to promptly update account and payment information,
	including email address, payment method, and payment card expiration date, so that we can complete your transactions
	and contact you as needed. Sales tax will be added to the price of purchases as deemed required by us. We may change
	prices at any time. All payments shall be in U.S. dollars.&nbsp;
</p>

<p>
	You agree to pay all charges at the prices then in effect for your purchases and any applicable shipping fees, and
	you authorize us to charge your chosen payment provider for any such amounts upon placing your order. We reserve the
	right to correct any errors or mistakes in pricing, even if we have already requested or received payment.&nbsp;
</p>

<p>
	We reserve the right to refuse any order placed through the Site. We may, in our sole discretion, limit or cancel
	quantities purchased per person, per household, or per order. These restrictions may include orders placed by or
	under the same customer account, the same payment method, and/or orders that use the same billing or shipping
	address. We reserve the right to limit or prohibit orders that, in our sole judgment, appear to be placed by
	dealers, resellers, or distributors.&nbsp;
</p>

<p>&nbsp;</p>

<p id="8"><strong>8. REFUNDS POLICY</strong></p>

<p>All sales are final and no refund will be issued.&nbsp;</p>

<p>&nbsp;</p>

<p id="9"><strong>9. PROHIBITED ACTIVITIES</strong></p>

<p>
	You may not access or use the Site for any purpose other than that for which we make the Site available. The Site
	may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved
	by us.&nbsp;
</p>

<p>As a user of the Site, you agree not to:&nbsp;</p>

<p className="ml-20">
	Systematically retrieve data or other content from the Site to create or compile, directly or indirectly, a
	collection, compilation, database, or directory without written permission from us.&nbsp;
</p>

<p className="ml-20">
	Trick, defraud, or mislead us and other users, especially in any attempt to learn sensitive account information such
	as user passwords.&nbsp;
</p>

<p className="ml-20">
	Circumvent, disable, or otherwise interfere with security-related features of the Site, including features that
	prevent or restrict the use or copying of any Content or enforce limitations on the use of the Site and/or the
	Content contained therein.
</p>

<p className="ml-30">Disparage, tarnish, or otherwise harm, in our opinion, us and/or the Site.&nbsp;</p>

<p className="ml-30">
	Use any information obtained from the Site in order to harass, abuse, or harm another person. Make improper use of
	our support services or submit false reports of abuse or misconduct. Use the Site in a manner inconsistent with any
	applicable laws or regulations.&nbsp;
</p>

<p className="ml-30">Engage in unauthorized framing of or linking to the Site.&nbsp;</p>

<p className="ml-20">
	Upload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, or other material, including
	excessive use of capital letters and spamming (continuous posting of repetitive text), that interferes with any
	party’s uninterrupted use and enjoyment of the Site or modifies, impairs, disrupts, alters, or interferes with
	the use, features, functions, operation, or maintenance of the LSAT Exams.&nbsp;
</p>

<p className="ml-20">
	Engage in any automated use of the system, such as using scripts to send comments or messages, or using any data
	mining, robots, or similar data gathering and extraction tools.&nbsp;
</p>

<p className="ml-30">Delete the copyright or other proprietary rights notice from any Content.&nbsp;</p>

<p className="ml-20">
	Attempt to impersonate another user or person or use the username of another user.&nbsp;
</p>

<p className="ml-20">
	Upload or transmit (or attempt to upload or to transmit) any material that acts as a passive or active information
	collection or transmission mechanism, including without limitation, clear graphics interchange formats
	(“gifs”), 1×1 pixels, web bugs, cookies, or other similar devices (sometimes referred to as
	“spyware” or “passive collection mechanisms” or “pcms”).&nbsp;
</p>

<p className="ml-30">
	Interfere with, disrupt, or create an undue burden on the Site or the networks or services connected to the Site.
	Harass, annoy, intimidate, or threaten any of our employees or agents engaged in providing any portion of the
	LSAT Exams to you.&nbsp;
</p>

<p className="ml-20">
	Attempt to bypass any measures of the Site designed to prevent or restrict access to the Site, or any portion of the
	Site.&nbsp;
</p>

<p className="ml-20">
	Copy or adapt the Site’s software, including but not limited to Flash, PHP, HTML, JavaScript, or other code.
	Except as permitted by applicable law, decipher, decompile, disassemble, or reverse engineer any of the software
	comprising or in any way making up a part of the Site.&nbsp;
</p>

<p className="ml-20">
	Except as may be the result of standard search engine or Internet browser usage, use, launch, develop, or distribute
	any automated system, including without limitation, any spider, robot, cheat utility, scraper, or offline reader
	that accesses the Site, or using or launching any unauthorized script or other software. Use a buying agent or
	purchasing agent to make purchases on the Site.&nbsp;
</p>

<p className="ml-20">
	Make any unauthorized use of the LSAT Exams, including collecting usernames and/or email addresses of
	users by electronic or other means for the purpose of sending unsolicited email, or creating user accounts by
	automated means or under false pretenses.&nbsp;
</p>

<p className="ml-20">
	Use the LSAT Exams as part of any effort to compete with us or otherwise use the Site and/or the Content
	for any revenue-generating endeavor or commercial enterprise.&nbsp;
</p>

<p className="ml-30">Use the Site to advertise or offer to sell goods and services.&nbsp;</p>

<p className="ml-30">&nbsp;</p>

<p id="10"><strong>10. USER GENERATED CONTRIBUTIONS</strong></p>

<p>
	The Site may invite you to chat, contribute to, or participate in blogs, message boards, online forums, and other
	functionality, and may provide you with the opportunity to create, submit, post, display, transmit, perform,
	publish, distribute, or broadcast content and materials to us or on the Site, including but not limited to text,
	writings, video, audio, photographs, graphics, comments, suggestions, or personal information or other material
	(collectively, "Contributions"). Contributions may be viewable by other users of the Site and through
	third-party websites. As such, any Contributions you transmit may be treated as non-confidential and
	non-proprietary. When you create or make available any Contributions, you thereby represent and warrant that:&nbsp;
</p>

<p className="ml-20">
	The creation, distribution, transmission, public display, or performance, and the accessing, downloading, or copying
	of your Contributions do not and will not infringe the proprietary rights, including but not limited to the
</p>

<p className="ml-20">copyright, patent, trademark, trade secret, or moral rights of any third party.&nbsp;</p>

<p className="ml-20">
	You are the creator and owner of or have the necessary licenses, rights, consents, releases, and permissions to use
	and to authorize us, the Site, and other users of the Site to use your Contributions in any manner contemplated by
	the Site and these Terms of Use.&nbsp;
</p>

<p className="ml-20">
	You have the written consent, release, and/or permission of each and every identifiable individual person in your
	Contributions to use the name or likeness of each and every such identifiable individual person to enable inclusion
	and use of your Contributions in any manner contemplated by the Site and these Terms of Use. Your Contributions are
	not false, inaccurate, or misleading.&nbsp;
</p>

<p className="ml-20">
	Your Contributions are not unsolicited or unauthorized advertising, promotional materials, pyramid schemes, chain
	letters, spam, mass mailings, or other forms of solicitation.&nbsp;
</p>

<p className="ml-20">
	Your Contributions are not obscene, lewd, lascivious, filthy, violent, harassing, libelous, slanderous, or otherwise
	objectionable (as determined by us).&nbsp;
</p>

<p className="ml-20">Your Contributions do not ridicule, mock, disparage, intimidate, or abuse anyone.&nbsp;</p>

<p className="ml-20">
	Your Contributions are not used to harass or threaten (in the legal sense of those terms) any other person and to
	promote violence against a specific person or class of people.&nbsp;
</p>

<p className="ml-20">Your Contributions do not violate any applicable law, regulation, or rule.&nbsp;</p>

<p className="ml-20">
	Your Contributions do not violate the privacy or publicity rights of any third party.&nbsp;
</p>

<p className="ml-20">
	Your Contributions do not violate any applicable law concerning child pornography, or otherwise intended to protect
	the health or well-being of minors.&nbsp;
</p>

<p className="ml-20">
	Your Contributions do not include any offensive comments that are connected to race, national origin, gender, sexual
	preference, or physical handicap.&nbsp;
</p>

<p className="ml-20">
	Your Contributions do not otherwise violate, or link to material that violates, any provision of these Terms of Use,
	or any applicable law or regulation.&nbsp;
</p>

<p className="mr-23">
	Any use of the Site or the LSAT Exams in violation of the foregoing violates these Terms of Use and may
	result in, among other things, termination or suspension of your rights to use the Site.&nbsp;
</p>

<p className="mr-23">
	Additionally, you represent and warrant that you will not use the Site or Marketplace for any criminal, illegal, or
	otherwise prohibited use, including (but not limited to) activities related to money laundering, drugs trafficking,
	human trafficking, weapon trafficking, terrorism, securities fraud, or tax evasion.
</p>

<p className="mr-23">
	You further represent and warrant that you will not use Services or any part thereof to assist any other party in
	activities which are not compatible with their domestic or international civil or criminal laws.
</p>

<p className="mr-23">
	From time to time as required by various Money Laundering regulations and regulatory bodies you may be required to
	provide identification documents in order to prove identification or ownership of banking facilities. In the event
	that LSAT Gains is required to examine personal information relating to a user, LSAT Gains reserves the right to suspend or pause
	your account until such time as you have reasonably identified yourself or ownership of banking facility.
</p>

<p className="mr-23">
	During such suspension time You will not be able to access any Services or Funds already deposited into your LSAT Gains
	Account.
</p>

<p className="mr-23">
	At all times You agree to indemnify and hold harmless LSAT Gains for any claims or causes of action arising from or out of
	any investigation or enquiries made from any government or extra-governmental body responsible for financial
	regulatory conduct that holds jurisdiction over the User.
</p>

<p className="mr-23">&nbsp;</p>

<p id="11"><strong>11. CONTRIBUTION LICENSE</strong></p>

<p>
	By posting your Contributions to any part of the Site or making Contributions accessible to the Site by linking your
	account from the Site to any of your social networking accounts, you automatically grant, and you represent and
	warrant that you have the right to grant, to us an unrestricted, unlimited, irrevocable, perpetual, non-exclusive,
	transferable, royalty-free, fully-paid, worldwide right, and license to host, use, copy, reproduce, disclose, sell,
	resell, publish, broadcast, retitle, archive, store, cache, publicly perform, publicly display, reformat, translate,
	transmit, excerpt (in whole or in part), and distribute such Contributions (including, without limitation, your
	image and voice) for any purpose, commercial, advertising, or otherwise, and to prepare derivative works of, or
	incorporate into other works, such Contributions, and grant and authorize sublicenses of the foregoing. The use and
	distribution may occur in any media formats and through any media channels.&nbsp;
</p>

<p>
	This license will apply to any form, media, or technology now known or hereafter developed, and includes our use of
	your name, company name, and franchise name, as applicable, and any of the trademarks, service marks, trade names,
	logos, and personal and commercial images you provide. You waive all moral rights in your Contributions, and you
	warrant that moral rights have not otherwise been asserted in your Contributions.&nbsp;
</p>

<p>
	We do not assert any ownership over your Contributions. You retain full ownership of all of your Contributions and
	any intellectual property rights or other proprietary rights associated with your Contributions. We are not liable
	for any statements or representations in your Contributions provided by you in any area on the Site. You are solely
	responsible for your Contributions to the Site and you expressly agree to exonerate us from any and all
	responsibility and to refrain from any legal action against us regarding your Contributions.
</p>

<p className="mr-6">
	We have the right, in our sole and absolute discretion, (1) to edit, redact, or otherwise change any Contributions;
	(2) to re-categorize any Contributions to place them in more appropriate locations on the Site; and (3) to
	pre-screen or delete any Contributions at any time and for any reason, without notice. We have no obligation to
	monitor your Contributions.&nbsp;
</p>

<p className="mr-6">&nbsp;</p>

<p id="12"><strong>12. MOBILE APPLICATION LICENSE</strong></p>

<p><strong>Use License</strong></p>

<p>
	If you access the LSAT Exams via a mobile application, then we grant you a revocable, non-exclusive, non
	transferable, limited right to install and use the mobile application on wireless electronic devices owned or
	controlled by you, and to access and use the mobile application on such devices strictly in accordance with the
	terms and conditions of this mobile application license contained in these Terms of Use. You shall not: (1) except
	as permitted by applicable law, decompile, reverse engineer, disassemble, attempt to derive the source code of, or
	decrypt the application; (2) make any modification, adaptation, improvement, enhancement, translation, or derivative
	work from the application; (3) violate any applicable laws, rules, or regulations in connection with your access or
	use of the application; (4) remove, alter, or obscure any proprietary notice (including any notice of copyright or
	trademark) posted by us or the licensors of the application; (5) use the application for any revenue generating
	endeavor, commercial enterprise, or other purpose for which it is not designed or intended; (6) make the application
	available over a network or other environment permitting access or use by multiple devices or users at the same
	time; (7) use the application for creating a product, service, or software that is, directly or indirectly,
	competitive with or in any way a substitute for the application; (8) use the application to send automated queries
	to any website or to send any unsolicited commercial e-mail; or (9) use any proprietary information or any of our
	interfaces or our other intellectual property in the design, development, manufacture, licensing, or distribution of
	any applications, accessories, or devices for use with the application.&nbsp;
</p>

<p><strong>Apple and Android Devices</strong></p>

<p>
	The following terms apply when you use a mobile application obtained from either the Apple Store or Google Play
	(each an “App Distributor”) to access the LSAT Exams: (1) the license granted to you for our
	mobile application is limited to a non-transferable license to use the application on a device that utilizes the
	Apple iOS or Android operating systems, as applicable, and in accordance with the usage rules set forth in the
	applicable App Distributor’s terms of service; (2) we are responsible for providing any maintenance and
	support services with respect to the mobile application as specified in the terms and conditions of this mobile
	application license contained in these Terms of Use or as otherwise required under applicable law, and you
	acknowledge that each App Distributor has no obligation whatsoever to furnish any maintenance and support services
	with respect to the mobile application; (3) in the event of any failure of the mobile application to conform to any
	applicable warranty, you may notify the applicable App Distributor, and the App Distributor, in accordance with its
	terms and policies, may refund the purchase price, if any, paid for the mobile application, and to the maximum
	extent permitted by applicable law, the App Distributor will have no other warranty obligation whatsoever with
	respect to the mobile application; (4) you represent and warrant that (i) you are not located in a country that is
	subject to a U.S. government embargo, or that has been designated by the U.S. government as a “terrorist
	supporting” country and (ii) you are not listed on any U.S. government list of prohibited or restricted
	parties; (5) you must comply with applicable third-party terms of agreement when using the mobile application, e.g.,
	if you have a VoIP application, then you must not be in violation of their wireless data service agreement when
	using the mobile application; and (6) you acknowledge and agree that the App Distributors are third party
	beneficiaries of the terms and conditions in this mobile application license contained in these Terms of Use, and
	that each App Distributor will have the right (and will be deemed to have accepted the right) to enforce the terms
	and conditions in this mobile application license contained in these Terms of Use against you as a third-party
	beneficiary thereof.
</p>

<p>&nbsp;</p>

<p id="13"><strong>13. SOCIAL MEDIA </strong></p>

<p>
	As part of the functionality of the Site, you may link your account with online accounts you have with third-party
	service providers (each such account, a “Third-Party Account”) by either: (1) providing your Third-Party
	Account login information through the Site; or (2) allowing us to access your Third-Party Account, as is permitted
	under the applicable terms and conditions that govern your use of each Third-Party Account. You represent and
	warrant that you are entitled to disclose your Third-Party Account login information to us and/or grant us access to
	your Third-Party Account, without breach by you of any of the terms and conditions that govern your use of the
	applicable Third-Party Account, and without obligating us to pay any fees or making us subject to any usage
	limitations imposed by the third-party service provider of the Third-Party Account. By granting us access to any
	Third-Party Accounts, you understand that (1) we may access, make available, and store (if applicable) any content
	that you have provided to and stored in your Third Party Account (the “Social Network Content”) so that
	it is available on and through the Site via your account, including without limitation any friend lists and (2) we
	may submit to and receive from your Third-Party Account additional information to the extent you are notified when
	you link your account with the Third-Party Account. Depending on the Third-Party Accounts you choose and subject to
	the privacy settings that you have set in such Third-Party Accounts, personally identifiable information that you
	post to your Third-Party Accounts may be available on and through your account on the Site. Please note that if a
	Third-Party Account or associated service becomes unavailable or our access to such Third-Party Account is
	terminated by the third-party service provider, then Social Network Content may no longer be available on and
	through the Site. You will have the ability to disable the connection between your account on the Site and your
	Third-Party Accounts at any time. PLEASE NOTE THAT YOUR RELATIONSHIP WITH THE THIRD PARTY SERVICE PROVIDERS
	ASSOCIATED WITH YOUR THIRD-PARTY ACCOUNTS IS GOVERNED SOLELY BY YOUR AGREEMENT(S) WITH SUCH THIRD-PARTY SERVICE
	PROVIDERS. We make no effort to review any Social Network Content for any purpose, including but not limited to, for
	accuracy, legality, or non-infringement, and we are not responsible for any Social Network Content. You acknowledge
	and agree that we may access your email address book associated with a Third-Party Account and your contacts list
	stored on your mobile device or tablet computer solely for purposes of identifying and informing you of those
	contacts who have also registered to use the Site. You can deactivate the connection between the Site and your
	Third-Party Account by contacting us using the contact information below or through your account settings (if
	applicable). We will attempt to delete any information stored on our servers that was obtained through such
	Third-Party Account, except the username and profile picture that become associated with your account.&nbsp;
</p>

<p>&nbsp;</p>

<p id="14"><strong>14. SUBMISSIONS</strong></p>

<p>
	You acknowledge and agree that any questions, comments, suggestions, ideas, feedback, or other information regarding
	the Site or the LSAT Exams ("Submissions") provided by you to us are non-confidential and shall
	become our sole property. We shall own exclusive rights, including all intellectual property rights, and shall be
	entitled to the unrestricted use and dissemination of these Submissions for any lawful purpose, commercial or
	otherwise, without acknowledgment or compensation to you. You hereby waive all moral rights to any such Submissions,
	and you hereby warrant that any such Submissions are original with you or that you have the right to submit such
	Submissions. You agree there shall be no recourse against us for any alleged or actual infringement or
	misappropriation of any proprietary right in your Submissions.&nbsp;
</p>

<p>&nbsp;</p>

<p id="15"><strong>15. THIRD-PARTY WEBSITES AND CONTENT AND USE OF THIRD PARTIES</strong></p>

<p>
	The Site may contain (or you may be sent via the Site or the LSAT Exams) links to other websites
	("Third Party Websites") as well as articles, photographs, text, graphics, pictures, designs, music,
	sound, video, information,
</p>

<p>
	applications, software, and other content or items belonging to or originating from third parties ("Third-Party
	Content"). Such Third-Party Websites and Third-Party Content are not investigated, monitored, or checked for
	accuracy, appropriateness, or completeness by us, and we are not responsible for any Third Party Websites accessed
	through the Site or any Third-Party Content posted on, available through, or installed from the Site, including the
	content, accuracy, offensiveness, opinions, reliability, privacy practices, or other policies of or contained in the
	Third-Party Websites or the Third-Party Content. Inclusion of, linking to, or permitting the use or installation of
	any Third-Party Websites or any Third-Party Content does not imply approval or endorsement thereof by us. If you
	decide to leave the Site and access the Third-Party Websites or to use or install any Third-Party Content, you do so
	at your own risk, and you should be aware these Terms of Use no longer govern. You should review the applicable
	terms and policies, including privacy and data gathering practices, of any website to which you navigate from the
	Site or relating to any applications you use or install from the Site. Any purchases you make through Third-Party
	Websites will be through other websites and from other companies, and we take no responsibility whatsoever in
	relation to such purchases which are exclusively between you and the applicable third party. You agree and
	acknowledge that we do not endorse the products or services offered on Third-Party Websites and you shall hold us
	harmless from any harm caused by your purchase of such products or services. Additionally, you shall hold us
	harmless from any losses sustained by you or harm caused to you relating to or resulting in any way from any
	Third-Party Content or any contact with Third-Party Websites.
</p>

<p>
	From time to time LSAT Gains may use third parties to provide or conduct some of their services. These third parties can be
	used within the ordinary course of business or in the event of extreme events such as service updates or service
	outages by LSAT Gains at our discretion. LSAT Gains has no obligation to notify you of the use of such third parties.
</p>

<p>
	LSAT Gains will hold no liability for the deployment of, use of, or interact with those third parties including their
	software or services, regardless of how the interaction between you and them occurs. This includes those
	interactions which take place as a direct result of using the Site.&nbsp;
</p>

<p>&nbsp;</p>

<p id="16"><strong>16. ADVERTISERS</strong></p>

<p>
	We allow advertisers to display their advertisements and other information in certain areas of the Site, such as
	sidebar advertisements or banner advertisements. If you are an advertiser, you shall take full responsibility for
	any advertisements you place on the Site and any services provided on the Site or products sold through those
	advertisements. Further, as an advertiser, you warrant and represent that you possess all rights and authority to
	place advertisements on the Site, including, but not limited to, intellectual property rights, publicity rights, and
	contractual rights. We simply provide the space to place such advertisements, and we have no other relationship with
	advertisers.&nbsp;
</p>

<p>&nbsp;</p>

<p id="17"><strong>17. SITE MANAGEMENT</strong></p>

<p>
	We reserve the right, but not the obligation, to: (1) monitor the Site for violations of these Terms of Use; (2)
	take appropriate legal action against anyone who, in our sole discretion, violates the law or these Terms of Use,
	including without limitation, reporting such user to law enforcement authorities; (3) in our sole discretion and
	without limitation, refuse, restrict access to, limit the availability of, or disable (to the extent technologically
	feasible) any of your Contributions or any portion thereof; (4) in our sole discretion and without limitation,
	notice, or liability, to remove from the Site or otherwise disable all files and content that are excessive in size
	or are in any way burdensome to our systems; and (5) otherwise manage the Site in a manner designed to protect our
	rights and property and to facilitate the proper functioning of the Site.&nbsp;
</p>

<p>&nbsp;</p>

<p id="18"><strong>18. PRIVACY POLICY</strong></p>

<p>
	We care about data privacy and security. Please review our Privacy Policy: www.lsatgains.com/privacypolicy. By using
	the Site or the LSAT Exams, you agree to be bound by our Privacy Policy, which is incorporated into these
	Terms of Use. Please be advised the Site is hosted in the United States. If you access the Site from any other
	region of the world with laws or other requirements governing personal data collection, use, or disclosure that
	differ from applicable laws in the United States, then through your continued use of the Site, you are transferring
	your data to the United States, and you agree to have your data transferred to and processed in the United States.
	Further, we do not knowingly accept, request, or solicit information from children or knowingly market to children.
	Therefore, in accordance with the U.S. Children’s Online Privacy Protection Act, if we receive actual
	knowledge that anyone under the age of 13 has provided personal information to us without the requisite and
	verifiable parental consent, we will delete that information from the Site as quickly as is reasonably
	practical.&nbsp;
</p>

<p>&nbsp;</p>

<p id="19"><strong>19. COPYRIGHT INFRINGEMENTS</strong></p>

<p>
	We respect the intellectual property rights of others. If you believe that any material available on or through the
	Site infringes upon any copyright you own or control, please immediately notify us using the contact information
	provided below (a “Notification”). A copy of your Notification will be sent to the person who posted or
	stored the material addressed in the Notification. Please be advised that pursuant to applicable law you may be held
	liable for damages if you make material misrepresentations in a Notification. Thus, if you are not sure that
	material located on or linked to by the Site infringes your copyright, you should consider first contacting an
	attorney.&nbsp;
</p>

<p>&nbsp;</p>

<p id="20"><strong>20. TERM AND TERMINATION</strong></p>

<p>
	These Terms of Use shall remain in full force and effect while you use the Site. WITHOUT LIMITING ANY OTHER
	PROVISION OF THESE TERMS OF USE, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY,
	DENY ACCESS TO AND USE OF THE SITE (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY REASON OR FOR NO
	REASON, INCLUDING WITHOUT LIMITATION FOR BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE
	TERMS OF USE OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE YOUR USE OR PARTICIPATION IN THE SITE&nbsp; OR
	DELETE YOUR ACCOUNT AND ANY CONTENT OR INFORMATION THAT YOU POSTED AT ANY TIME, WITHOUT WARNING, IN OUR SOLE
	DISCRETION.&nbsp;
</p>

<p>
	If we terminate or suspend your account for any reason, you are prohibited from registering and creating a new
	account under your name, a fake or borrowed name, or the name of any third party, even if you may be acting on
	behalf of the third party. In addition to terminating or suspending your account, we reserve the right to take
	appropriate legal action, including without limitation pursuing civil, criminal, and injunctive redress.&nbsp;
</p>

<p>&nbsp;</p>

<p id="21"><strong>21. MODIFICATIONS AND INTERRUPTIONS</strong></p>

<p>
	We reserve the right to change, modify, or remove the contents of the Site at any time or for any reason at our sole
	discretion without notice. However, we have no obligation to update any information on our Site. We also reserve the
	right to modify or discontinue all or part of the LSAT Exams without notice at any time. We will not be
	liable to you or any third party for any modification, price change, suspension, or discontinuance of the Site or
	the LSAT Exams.&nbsp;
</p>

<p>
	We cannot guarantee the Site will be available at all times. We may experience hardware, software, or other problems
	or need to perform maintenance related to the Site, resulting in interruptions, delays, or errors. We reserve the
	right to change, revise, update, suspend, discontinue, or otherwise modify the Site or the LSAT Exams at
	any time or for any reason without notice to you. You agree that we have no liability whatsoever for any loss,
	damage, or inconvenience caused by your inability to access or use the Site or the LSAT Exams during any
	downtime or discontinuance of the Site or the LSAT Exams. Nothing in these
</p>

<p>
	Terms of Use will be construed to obligate us to maintain and support the Site or the LSAT Exams or to
	supply any corrections, updates, or releases in connection therewith.&nbsp;
</p>

<p>&nbsp;</p>

<p id="22"><strong>22. GOVERNING LAW</strong></p>

<p>
	These Terms of Use and your use of the Site is governed by and construed in accordance with the laws of the State of
	Delaware applicable to agreements made and to be entirely performed within the State of Delaware, without regard to
	its conflict of law principles. Arbitration shall be held within the State of Delaware.
</p>

<p>&nbsp;</p>

<p id="23"><strong>23. DISPUTE RESOLUTION</strong></p>

<p><strong>Binding Arbitration</strong></p>

<p>
	If the Parties are unable to resolve a Dispute through informal negotiations, the Dispute (except those Disputes
	expressly excluded below) will be finally and exclusively resolved through binding arbitration. YOU UNDERSTAND THAT
	WITHOUT THIS PROVISION, YOU WOULD HAVE THE RIGHT TO SUE IN COURT AND HAVE A JURY TRIAL. The arbitration shall be
	commenced and conducted under the Commercial Arbitration Rules of the American Arbitration Association
	("AAA") and, where appropriate, the AAA’s Supplementary Procedures for Consumer Related Disputes
	("AAA Consumer Rules"), both of which are available at the AAA website: <u>www.adr.org</u>. Your
	arbitration fees and your share of arbitrator compensation shall be governed by the AAA Consumer Rules and, where
	appropriate, limited by the AAA Consumer Rules. If such costs are determined by the arbitrator to be excessive, we
	will pay all arbitration fees and expenses. The arbitration may be conducted in person, through the submission of
	documents, by phone, or online. The arbitrator will make a decision in writing, but need not provide a statement of
	reasons unless requested by either Party. The arbitrator must follow applicable law, and any award may be challenged
	if the arbitrator fails to do so. Except where otherwise required by the applicable AAA rules or applicable law, the
	arbitration will take place in Delaware. Except as otherwise provided herein, the Parties may litigate in court to
	compel arbitration, stay proceedings pending arbitration, or to confirm, modify, vacate, or enter judgment on the
	award entered by the arbitrator.&nbsp;
</p>

<p>
	If for any reason, a Dispute proceeds in court rather than arbitration, the Dispute shall be commenced or prosecuted
	in the state and federal courts located in Delaware, and the Parties hereby consent to, and waive all defenses of
	lack of personal jurisdiction, and forum non conveniens with respect to venue and jurisdiction in such state and
	federal courts. Application of the United Nations Convention on Contracts for the International Sale of Goods and
	the Uniform Computer Information Transaction Act (UCITA) is excluded from these Terms of Use.&nbsp;
</p>

<p>
	If this provision is found to be illegal or unenforceable, then neither Party will elect to arbitrate any Dispute
	falling within that portion of this provision found to be illegal or unenforceable, and such Dispute shall be
	decided by a court of competent jurisdiction within the courts listed for jurisdiction above, and the Parties agree
	to submit to the personal jurisdiction of that court.&nbsp;
</p>

<p><strong>Restrictions</strong></p>

<p>
	The Parties agree that any arbitration shall be limited to the Dispute between the Parties individually. To the full
	extent permitted by law, (a) no arbitration shall be joined with any other proceeding; (b) there is no right or
	authority for any Dispute to be arbitrated on a class-action basis or to utilize class action procedures; and (c)
	there is no right or authority for any Dispute to be brought in a purported representative capacity on behalf of the
	general public or any other persons.&nbsp;
</p>

<p><strong>Exceptions to Arbitration</strong></p>

<p>
	The Parties agree that the following Disputes are not subject to the above provisions concerning binding
	arbitration: (a) any Disputes seeking to enforce or protect, or concerning the validity of, any of the intellectual
	property rights of a Party; (b) any Dispute related to, or arising from, allegations of theft, piracy, invasion of
	privacy, or unauthorized use; and (c) any claim for injunctive relief. If this provision is found to be illegal or
	unenforceable, then neither Party will elect to arbitrate any Dispute falling within that portion of this provision
	found to be illegal or unenforceable and such Dispute shall be decided by a court of competent jurisdiction within
	the courts listed for jurisdiction above, and the Parties agree to submit to the personal jurisdiction of that
	court.&nbsp;
</p>

<p>&nbsp;</p>

<p id="24"><strong>24. CORRECTIONS</strong></p>

<p>
	There may be information on the Site that contains typographical errors, inaccuracies, or omissions that may relate
	to the LSAT Exams, including descriptions, pricing, availability, and various other information. We
	reserve the right to correct any errors, inaccuracies, or omissions and to change or update the information on the
	Site at any time, without prior notice.&nbsp;
</p>

<p>&nbsp;</p>

<p id="25"><strong>25. DISCLAIMER</strong></p>

<p>
	THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE THAT YOUR USE OF THE SITE AND OUR SERVICES WILL
	BE AT YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN
	CONNECTION WITH THE SITE AND YOUR USE THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF
	MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS
	ABOUT THE ACCURACY OR COMPLETENESS OF THE SITE’S CONTENT OR THE CONTENT OF ANY WEBSITES LINKED TO THE SITE AND
	WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND
	MATERIALS, (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE
	OF THE SITE, (3) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION
	AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SITE
	OR THE MARKETPLACE OFFERINGS, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR
	THROUGH THE SITE BY ANY THIRD PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS
	OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE
	AVAILABLE VIA THE SITE. WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE
	ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SITE, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE
	APPLICATION FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE
	FOR MONITORING ANY TRANSACTION BETWEEN YOU AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE
	PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND
	EXERCISE CAUTION WHERE APPROPRIATE.&nbsp;
</p>

<p>
	YOU ACCEPT THE INHERENT SECURITY RISKS OF PROVIDING INFORMATION AND DEALING ONLINE OVER THE INTERNET, AND AGREE THAT
	WE HAVE NO LIABILITY OR RESPONSIBILITY FOR ANY BREACH OF SECURITY UNLESS IT IS DUE TO OUR GROSS NEGLIGENCE.
</p>

<p>
	WE WILL NOT BE RESPONSIBLE OR LIABLE TO YOU FOR ANY LOSSES YOU INCUR AS THE RESULT OF YOUR USE OF THE SERVICES,
	INCLUDING BUT NOT LIMITED TO ANY LOSSES, DAMAGES OR CLAIMS ARISING FROM: (A) USER ERROR, SUCH AS FORGOTTEN PASSWORDS
	OR INCORRECTLY CONSTRUED SMART CONTRACTS OR OTHER TRANSACTIONS; (B) SERVER FAILURE OR DATA LOSS; (C) CORRUPTED
	FILES; (D) UNAUTHORIZED ACCESS OR ACTIVITIES BY THIRD PARTIES, INCLUDING BUT NOT LIMITED TO THE USE OF VIRUSES,
	PHISHING, BRUTEFORCING OR OTHER MEANS OF ATTACK AGAINST THE APP.&nbsp;
</p>

<p>&nbsp;</p>

<p id="26"><strong>26. LIMITATIONS OF LIABILITY</strong></p>

<p className="mr-2">
	IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT,
	INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE,
	LOSS OF DATA, OR OTHER DAMAGES ARISING FROM YOUR USE OF THE SITE OR THE MARKETPLACE OFFERINGS, EVEN IF WE HAVE BEEN
	ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR LIABILITY
	TO YOU FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION, WILL AT ALL TIMES BE LIMITED TO THE LESSER
	OF THE AMOUNT PAID, IF ANY, BY YOU TO US OR __________.&nbsp;
</p>

<p className="mr-2">
	CERTAIN US STATE LAWS AND INTERNATIONAL LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR
	LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS OR LIMITATIONS MAY
	NOT APPLY TO YOU, AND YOU MAY HAVE ADDITIONAL RIGHTS.&nbsp;
</p>

<p className="mr-2">&nbsp;</p>

<p id="27"><strong>27. INDEMNIFICATION</strong></p>

<p>
	You agree to defend, indemnify, and hold us harmless, including our subsidiaries, affiliates, and all of our
	respective officers, agents, partners, and employees, from and against any loss, damage, liability, claim, or
	demand, including reasonable attorneys’ fees and expenses, made by any third party due to or arising out of:
	(1) your Contributions; (2) use of the exams; (3) breach of these Terms of Use; (4) any breach of
	your representations and warranties set forth in these Terms of Use; (5) your violation of the rights of a third
	party, including but not limited to intellectual property rights; or (6) any overt harmful act toward any other user
	of the Site or the LSAT Exams with whom you connected via the Site. Notwithstanding the foregoing, we
	reserve the right, at your expense, to assume the exclusive defense and control of any matter for which you are
	required to indemnify us, and you agree to cooperate, at your expense, with our defense of such claims. We will use
	reasonable efforts to notify you of any such claim, action, or proceeding which is subject to this indemnification
	upon becoming aware of it.&nbsp;
</p>

<p>&nbsp;</p>

<p id="29"><strong>29. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES</strong></p>

<p>
	Visiting the Site, sending us emails, and completing online forms constitute electronic communications. You consent
	to receive electronic communications, and you agree that all agreements, notices, disclosures, and other
	communications we provide to you electronically, via email and on the Site, satisfy any legal requirement that such
	communication be in&nbsp;
</p>

<p>
	writing. YOU HEREBY AGREE TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO
	ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE SITE.
	You hereby waive any rights or requirements under any statutes, regulations, rules, ordinances, or other laws in any
	jurisdiction which require an original signature or delivery or retention of non-electronic records, or to payments
	or the granting of credits by any means other than electronic means.
</p>

<p>&nbsp;</p>

<p id="30"><strong>30. CALIFORNIA USERS AND RESIDENTS </strong></p>

<p>
	If any complaint with us is not satisfactorily resolved, you can contact the Complaint Assistance Unit of the
	Division of Consumer Services of the California Department of Consumer Affairs in writing at 1625 North Market
	Blvd., Suite N 112, Sacramento, California 95834 or by telephone at (800) 952-5210 or (916) 445-1254.&nbsp;
</p>

<p>&nbsp;</p>

<p id="31"><strong>31. USER LIKENESS AND CONTENT USE</strong></p>

<p>
	By using our Site, you grant LSAT Gains a worldwide, non-exclusive, royalty-free license (with the right to sublicense)
	to use, copy, reproduce, process, adapt, modify, publish, transmit, display and distribute your likeness, image, or
	any other content you provide in any and all media or distribution methods (now known or later developed).This
	includes without limitation the use of your likeness or image on our website, in promotional or marketing materials,
	on our social media pages, and in other public-facing capacities related to LSAT Gains. This also applies to
	screenshots of our site which may contain your likeness, image, or other content you have shared with us.
</p>

<p>
	You understand that we may modify or adapt your content as necessary to transmit, display or distribute it over
	computer networks and in various media and/or make changes to your content as necessary to conform and adapt that
	content to any requirements or limitations of any networks, devices, services or media.
</p>

<p>
	You represent and warrant that you have all the rights, power and authority necessary to grant the rights granted
	herein to any content that you submit, including but not limited to any necessary releases for the use of your
	likeness or image.
</p>

<p>
	By accepting these Terms of Use, you waive any right to inspect or approve any intermediary version(s) or finished
	version(s) of the results of the use of your likeness. Further, you waive any right to royalties or other
	compensation arising from or related to the use of your likeness or image. Your continued use of our services
	following notification of any changes to this agreement constitutes acceptance of those changes. If you do not agree
	to these terms, please do not use our services.
</p>

<p>&nbsp;</p>

<p id="32"><strong>32. MISCELLANEOUS </strong></p>

<p>
	These Terms of Use and any policies or operating rules posted by us on the Site or in respect to the Marketplace
	Offerings constitute the entire agreement and understanding between you and us. Our failure to exercise or enforce
	any right or provision of these Terms of Use shall not operate as a waiver of such right or provision. These Terms
	of Use operate to the fullest extent permissible by law. We may assign any or all of our rights and obligations to
	others at any time. We shall not be responsible or liable for any loss, damage, delay, or failure to act caused by
	any cause beyond our reasonable control. You may not assign your rights under these Terms. If any provision or part
	of a provision of these Terms of Use is determined to be unlawful, void, or unenforceable, that provision or part of
	the provision is deemed severable from these Terms of Use and does not affect the validity and enforceability of any
	remaining provisions. There is no joint venture, partnership, employment or agency relationship created between you
	and us as a result of these Terms of Use or use of the LSAT Exams. You agree that these Terms of Use will
	not be construed against us by virtue of having drafted them. You hereby waive any and all defenses you may have
	based on the electronic form of these Terms of Use and the lack of signing by the parties hereto to execute these
	Terms of Use.&nbsp;
</p>

<p>&nbsp;</p>

<p id="33"><strong>33. CONTACT US</strong></p>

<p className="mr-2">
	In order to resolve a complaint regarding the Site or the LSAT Exams or to receive further information
	regarding use of the Site or the LSAT Exams, please contact us at:&nbsp;
</p>

<p><strong>LSAT Gains</strong></p>

{/* <p><strong>123 St</strong></p> */}

<p><strong>Miami, FL 33304</strong></p>

<p><strong>United States</strong></p>

<p>
	{/* <strong>Phone: (555)555-5555</strong><br /> */}
	<a href="mailto:contact@lsatgains.com" className="no-underline"><strong><u>contact@lsatgains.com</u></strong></a>
</p>
</div></div></div>
  );
}
